import { render, staticRenderFns } from "./PreciosButacasComponent.vue?vue&type=template&id=61aa9998"
import script from "./PreciosButacasComponent.vue?vue&type=script&lang=js"
export * from "./PreciosButacasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports